// extracted by mini-css-extract-plugin
module.exports = {"separation":"headerSeparation_separation__17m7Y"};